module.exports = true;


//////////////////
// WEBPACK FOOTER
// /~/core-js/library/modules/$.library.js
// module id = 1154
// module chunks = 0